<svg
    width="32"
    height="23"
    viewBox="0 0 32 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31 11.5H1M19.3333 1L31 11.5L19.3333 1ZM31 11.5L19.3333 22L31 11.5Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <style>
    svg {
      transform: rotate(180deg);
    }
  </style>